module.exports = ".content a{\n\tdisplay:block;\n\ttext-align:center;\n}\n\n#ban-area{\n    text-align:center;\n}\n\n#submit-ban{\n    position:relative;\n    top:35px;\n}\n\n.three-fourths-width{\n    width: 75%;\n}\n\n.btn-block{\n    width:20%;\n    display: inline-block;\n}\n\n.success-message{\n\tcolor:#6ee229;\n\ttext-align:center;\n}\n\n.error-message{\n\tcolor: red;\n\ttext-align:center;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/agent/agent-dashboard/dpp-override/dpp-override.component.css
// module id = ./src/app/agent/agent-dashboard/dpp-override/dpp-override.component.css
// module chunks = main